import fetch from '../../../common/services/api/fetch';
import getQueryStringForPageIdentifiers from '../getQueryStringForPageIdentifiers';

export default async function addLastFiltered(ids, filter, showNotif) {
    const queryString = getQueryStringForPageIdentifiers(ids);
    return fetch(
        `/ui/users/preferences/last_filtered/save${queryString}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filter),
        },
        showNotif,
        false,
        !showNotif,
    );
}
